import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Foot, PlayerSearchFilterStyles, SelectedAttributes, TopPercentiles } from '../../../styled-components/PlayerComponent.styles'
import { usePlayerSearch } from '../../../contexts/SearchPlayersContext'
import LabelText from '../../../ui/LabelText';
import CustomList from '../../../ui/CustomList';
import { IPlayerZonePosition } from '../../../types/IPlayerSearchResponse';
import Pitch from '../../Pitch';
import { IPositionSearchByZoneResponse } from '../../../types/IPositionSearchByZoneResponse';
import { ISectionState, SectionProps } from '../../../types/IPlayerSearchFilter';
import { KeyboardArrowDown, KeyboardArrowUp, Search } from '@mui/icons-material';
import BarChart from './BarChart';
import NumberTextField from '../../../ui/NumberTextField';
import Switch from '../../../ui/CustomSwitch';
import FilterDropdown from '../../../ui/FilterDropdown';
import PrimaryButton from '../../../ui/PrimaryButton';
import { IAttribute } from './SelectAttributes';
import { ITag } from './SelectTags';
import CloseIcon from '@mui/icons-material/Close';
import PlayerPositionProfile from './PlayerPositionProfile';
import { debounceFunction } from '../../../utils/debounceFunction';
import IApiResponse from '../../../types/IApiResponse';
import { postData } from '../../../services/api';
import handleApiResponse from '../../../utils/handleApiResponse';
import apiUrls from '../../../config/apiUrls';
//import { useLoading } from '../../../contexts/LoadingContext';
import { IPlayerAttributesData } from '../../../types/IPlayerAttributesData';
import { attributeSections } from '../../../data/attributeSection';
import SearchForSimilarPlayers from './SearchForSimilarPlayers';
import { IAgeStatistics } from '../../../types/IPlayerDetail';
import { IZoneArray } from '../../../types/IPitchProps';
import { useNotification } from '../../../contexts/NotificationContext';
import SecondaryButton from '../../../ui/SecondaryButton';
import SmallModal from '../../../ui/SmallModal';
import { fetchAllAreaByRegions, fetchAllClubLeagues } from '../../../services/dataService';
import InfoIcon from "../../../assets/icons/infoicon.svg";
import { useSearch } from '../../../contexts/PlayerSearchContext';
import { Dispatch, SetStateAction } from 'react';
import InputFeild from '../../../ui/InputFeild';


const footLabels = [
  { id: 1, name: 'Left footed' },
  { id: 2, name: 'Right footed' },
  { id: 3, name: 'Both footed' },
];

export interface ISelectedOption {
  region: string;
  optionId: number;
}

const valueSliderData = [
  { value: 26, number: 5 },
  { value: 27, number: 20 },
  { value: 28, number: 10 },
  { value: 29, number: 25 },
  { value: 30, number: 30 },
  { value: 31, number: 35 },
  { value: 32, number: 50 },
  { value: 33, number: 70 },
  { value: 34, number: 40 },
  { value: 35, number: 60 },
  { value: 36, number: 30 },
  { value: 37, number: 25 }
];

const wagesSliderData = [
  { wages: 26, number: 5 },
  { wages: 27, number: 20 },
  { wages: 28, number: 10 },
  { wages: 29, number: 25 },
  { wages: 30, number: 30 },
  { wages: 31, number: 35 },
  { wages: 32, number: 50 },
  { wages: 33, number: 70 },
  { wages: 34, number: 40 },
  { wages: 35, number: 60 },
  { wages: 36, number: 30 },
  { wages: 37, number: 25 }
];

// const options = [
//   { label: 'Their position', value: 'theirposition' },
//   { label: 'All positions', value: 'allpositions' },
// ];

interface IPlayerFilterSection {
  allPlayersPositions?: IPositionSearchByZoneResponse[];
  selectedPlayerPosition?: IPositionSearchByZoneResponse[];
  ageStatistics: IAgeStatistics;
  onSelectedAttributes?: (selectedData: IAttribute[]) => void;
  onSelectedTags?: (selectedData: ITag[]) => void;
  additionalData:string[]
  setAdditionalData?:Dispatch<SetStateAction<string[]>>;
  isFromSuccession?:boolean;
}

export interface PlayerFilterSectionRef {
  handleConfirmAttributes: (selectedData: IAttribute[]) => void;
  handleTagConfirm: (selectedData: ITag[]) => void;
}

const Section: React.FC<SectionProps> = ({ label, isOpen, toggle, children }) => (
  <div className='section'>
    <div className='filters-sub-header' onClick={toggle}>
      <LabelText className='player-search-text'>{label}</LabelText>
      <div className='section-right'>
        {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </div>
    </div>
    {isOpen && children}
  </div>
);

const PlayerFilterSection = forwardRef<PlayerFilterSectionRef, IPlayerFilterSection>(({ allPlayersPositions, selectedPlayerPosition,
  ageStatistics, onSelectedAttributes, onSelectedTags , setAdditionalData , additionalData , isFromSuccession }, ref) => {
  const { selectedPlayers, setAttributesDrawerOpen, setTagsDrawerOpen, selectedTags,
    clubLeagueData, regionAreaData, handleSelectedPlayer, handleSelectedPlayerZones,
    handleSelectedProfiles, handleSelectedAttributes, setIsSearchByAttributes, transferValue,trueValue,
    ageRange, contractUntilValue, selectedPlayerZones, selectedProfiles, allProfiles, selectedAttributesState,
    attributesDrawerOpen, isAllPosition, minAppearances, startsOnly, foot, regionValues, competitionValues,
    tagsDrawerOpen, setIsAltered, setAllProfiles, setTransferValue,setTrueValue, setContractUntilValue, setAgeRange,
    setIsAllPosition, setMinAppearances, setStartsOnly, setFoot, setRegionValues, setCompetitionValues, handleSelectedTags,
    setIsPlayerFilterChange, setIsExactMatchesOnly, isExactMatchesOnly, playerInitialAttributes, wagesValue, setWagesValue,
    currentPlayerPage, setCurrentPlayerPage, originPage, handleRegionAreaData, handleClubLeagueData, 
    isAffordabilityFilter, setIsAffordabilityFilter, isStylisticFilter, setIsStylisticFilter
  } = usePlayerSearch();
  const {setSelectedPositionIds} = useSearch()
  const { showNotification, hideNotification } = useNotification();
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const numberInputRef = useRef<HTMLInputElement>(null);
  const [isRemovePlayer, setIsRemovePlayer] = useState<boolean>(false);
  // const [additionalData, setAdditionalData] = useState<string[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<number[]>([]);
  const [allPlayerProfiles, setAllPlayerProfiles] = useState<IPositionSearchByZoneResponse[]>([]);
  const [selectedPosition, setSelectedPosition] = useState<IPositionSearchByZoneResponse[]>([]);
  const [playerTransferValue, setPlayerTransferValue] = useState<{ min: number, max: number }>({ min: 0, max: 0 });
  const [playerTrueValue, setPlayerTrueValue] = useState<{ min: number, max: number }>({ min: 0, max: 0 });
  const [playerWagesValue, setPlayerWagesValue] = useState<{ min: number, max: number }>({ min: 0, max: 0 });
  const [playerContractUntilValue, setPlayerContractUntilValue] = useState<{ min: number, max: number }>({ min: 0, max: 0 });
  const [playerAgeRange, setPlayerAgeRange] = useState<{ min: number, max: number }>({ min: 0, max: 0 });
  const [playerMinAppearances, setPlayerMinAppearances] = useState<number>(0);
  const [playerStartsOnly, setPlayerStartsOnly] = useState<boolean>(true);
  const [footValue, setFootValue] = useState<string>('');
  const [selectedFootOptions, setSelectedFootOptions] = useState<number[]>([]);
  const [competition, setCompetition] = useState<ISelectedOption[]>([]);
  const [region, setRegion] = useState<ISelectedOption[]>([]);
  const [selectedAttributes, setSelectedAttributes] = useState<IAttribute[]>([]);
  const [selectedPlayerTags, setSelectedPlayerTags] = useState<ITag[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>('allpositions');
  const [archetypeID, setArchetypeID] = useState<number>(0);
  const [activeArchetypeName, setActiveArchetypeName] = useState<string>('');
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
    
  const [isOpen, setIsOpen] = useState<ISectionState>({
    tags: false,
    financial: true,
    statistical: true,
    status: true,
    region: false,
    clubleague: false,
    Preferredfoot: false,
    toppercentiles: true
  });
  const [modalState, setModalState] = useState({
    isOpen: false,
    headerMessage: '',
    bodyMessage: '',
    acceptLabel: '',
    footerMessage: ''
  });
  const [isExactMatch, setIsExactMatch] = useState<boolean>(false);
  const [isAffordability, setIsAffordability] = useState<boolean>(true);
  const [isStlisticfit, setIsStylisticfit] = useState<boolean>(false);
  const [txtInputWidth, settxtInputWidth] = useState(playerMinAppearances ? (Math.max(50, playerMinAppearances.toString().length * 20)) : 50);
  useImperativeHandle(ref, () => ({
    handleConfirmAttributes,
    handleTagConfirm
  }));

  const arraysEqual = useCallback((arr1: number[], arr2: number[]): boolean => {
    if (arr1.length !== arr2.length) return false;
    return arr1.slice().sort().every((value, index) => value === arr2.slice().sort()[index]);
  }, []);

  const areAttributesEqual = useCallback((arr1: IAttribute[], arr2: IAttribute[]): boolean => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((attr, index) => (
      attr.id === arr2[index].id &&
      attr.label === arr2[index].label &&
      attr.checked === arr2[index].checked &&
      attr.percentile === arr2[index].percentile
    ));
  }, []);

  useEffect(() => {
    const fetchRegionAreaData = async () => {
      if (regionAreaData.length === 0) {
        try {
          const areaResponse = await fetchAllAreaByRegions();
          if (areaResponse.isSuccess) {
            handleRegionAreaData(areaResponse.data);
          } else {
            console.error('Failed to fetch area data:', areaResponse);
          }
        } catch (error) {
          console.error('Error fetching region area data:', error);
        }
      }
    };

    fetchRegionAreaData();
  }, [regionAreaData]);

  useEffect(() => {
    const fetchClubLeagueData = async () => {
      if (clubLeagueData.length === 0) {
        try {
          const leagueResponse = await fetchAllClubLeagues();
          if (leagueResponse.isSuccess) {
            handleClubLeagueData(leagueResponse.data);
          } else {
            console.error('Failed to fetch club league data:', leagueResponse);
          }
        } catch (error) {
          console.error('Error fetching club league data:', error);
        }
      }
    };
    fetchClubLeagueData();
  }, [clubLeagueData]);

  useEffect(() => {
    setPlayerTransferValue({ min: transferValue.min, max: transferValue.max })
  }, [transferValue])

  useEffect(() => {
    setPlayerTrueValue({ min: trueValue.min, max: trueValue.max })
  }, [trueValue])

  useEffect(() => {
    setPlayerWagesValue({ min: wagesValue.min, max: wagesValue.max });
  }, [wagesValue])

  useEffect(() => {
    setPlayerContractUntilValue({ min: contractUntilValue.min, max: contractUntilValue.max })
  }, [contractUntilValue])

  useEffect(() => {
    setSelectedAreas(selectedPlayerZones);
  }, [selectedPlayerZones])

  useEffect(() => {
    setAllPlayerProfiles(allProfiles);
  }, [allProfiles])

  useEffect(() => {
    const selectedPositions = allProfiles?.filter(position => selectedProfiles?.includes(position?.positionId!));
    setSelectedPosition(selectedPositions!)
  }, [allProfiles, selectedProfiles])

  useEffect(() => {
    setSelectedAttributes(selectedAttributesState);
  }, [selectedAttributesState])

  useEffect(() => {
    setSelectedOption(isAllPosition);
  }, [isAllPosition])

  useEffect(() => {
    setPlayerMinAppearances(minAppearances);
  }, [minAppearances])

  useEffect(() => {
    setPlayerStartsOnly(startsOnly);
  }, [startsOnly])

  useEffect(() => {
    setSelectedFootOptions(foot);
  }, [foot])

  useEffect(() => {
    setRegion(regionValues);
  }, [regionValues])

  useEffect(() => {
    setCompetition(competitionValues);
  }, [competitionValues])

  useEffect(() => {
    setSelectedPlayerTags(selectedTags);
  }, [selectedTags])

  useEffect(() => {
    setPlayerAgeRange({ min: ageRange.min, max: ageRange.max })
  }, [ageStatistics])

  useEffect(() => {
    setIsExactMatch(isExactMatchesOnly);
  }, [isExactMatchesOnly])

  useEffect(()=>{
    setIsAffordability(isAffordabilityFilter)
  },[isAffordabilityFilter])

  useEffect(()=>{
    setIsStylisticfit(isStylisticFilter)
  },[isStylisticFilter])

  useEffect(() => {
    if (additionalData.length > 0)
      showNotification('FilterNotification', generateMessage(), commonAction);
  }, [selectedAreas, selectedPosition, selectedAttributes, selectedOption, playerTransferValue,
    playerContractUntilValue, playerAgeRange, playerMinAppearances, playerStartsOnly, selectedFootOptions,
    competition, region, selectedPlayerTags, additionalData])

  useEffect(() => {
    if (selectedAreas && selectedAreas.length > 0) {
      fetchPositionData(selectedAreas);
    } else {
      setSelectedPosition([]);
      setAllPlayerProfiles([]);
    }
  }, [selectedAreas]);

  const compareAttributes = useCallback((attrs1: IAttribute[], attrs2: IAttribute[]) => {
    const finalResults = attrs1.map(attr1 => {
      const attr2 = attrs2.find(attr => attr.id === attr1.id);
      if (attr2) {
        return {
          ...attr1,
          isMadeUpScore: attr1.percentile !== attr2.percentile
        };
      }
      return attr1;
    });
    return finalResults;
  }, []);

  const handleRunNewSearch = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setCurrentPlayerPage(1)
    event.preventDefault();
    if (selectedPlayers.length > 0 && isRemovePlayer) {
      setModalState({
        ...modalState,
        isOpen: true,
        headerMessage: "Clear similar player?",
        bodyMessage: "This will not affect any of the other search criteria you have in play.",
        acceptLabel: 'Ok',
      });
      hideNotification();
    }
    else {
      const selectedAttributelist = playerInitialAttributes.flatMap(section => section.attributes).filter(attribute => attribute.checked);
      const finalAttributeList = compareAttributes(selectedAttributes, selectedAttributelist);
      const positionIdsArray: number[] = selectedPosition.map(position => position.positionId);
      handleSelectedProfiles(positionIdsArray);
      handleSelectedAttributes(finalAttributeList);
      setIsAllPosition(selectedOption);
      setTransferValue({ min: playerTransferValue.min, max: playerTransferValue.max })
      setTrueValue({min:playerTrueValue.min,max:playerTrueValue.max})
      setContractUntilValue({ min: playerContractUntilValue.min, max: playerContractUntilValue.max })
      setWagesValue({ min: playerWagesValue.min, max: playerWagesValue.max })
      setAgeRange({ min: playerAgeRange.min, max: playerAgeRange.max });
      setMinAppearances(playerMinAppearances);
      setStartsOnly(playerStartsOnly);
      setFoot(selectedFootOptions);
      setRegionValues(region);
      setCompetitionValues(competition);
      handleSelectedTags(selectedPlayerTags);
      setIsExactMatchesOnly(isExactMatch);
      setIsAffordabilityFilter(isAffordability)
      setIsStylisticFilter(isStlisticfit)
      setIsPlayerFilterChange(true);
      hideNotification();
      setAdditionalData?.([]);
    }
  }, [
    selectedPlayers, isRemovePlayer, playerInitialAttributes, selectedAttributes, selectedPosition,
    selectedOption, playerTransferValue,playerTrueValue, playerContractUntilValue, playerWagesValue, playerAgeRange,
    playerMinAppearances, playerStartsOnly, selectedFootOptions, competition, region, selectedPlayerTags,
    isExactMatch,isAffordability,isStlisticfit, hideNotification, setAdditionalData
  ]);

  const handleCancel = useCallback(() => {
    setPlayerTransferValue({ min: transferValue.min, max: transferValue.max });
    setPlayerTrueValue({ min: trueValue.min, max: trueValue.max });
    setPlayerWagesValue({ min: wagesValue.min, max: wagesValue.max })
    setPlayerContractUntilValue({ min: contractUntilValue.min, max: contractUntilValue.max })
    setSelectedAreas(selectedPlayerZones);
    setSelectedAttributes(selectedAttributesState);
    setSelectedOption(isAllPosition);
    setPlayerMinAppearances(minAppearances);
    setPlayerStartsOnly(startsOnly);
    setSelectedFootOptions(foot);
    setRegion(regionValues);
    setCompetition(competitionValues);
    setSelectedPlayerTags(selectedTags);
    setPlayerAgeRange({ min: ageStatistics.minAge, max: ageStatistics.maxAge })
    setIsExactMatch(isExactMatchesOnly);
    setIsAffordability(isAffordabilityFilter);
    setIsStylisticfit(isStylisticFilter);
    setAllPlayerProfiles(allProfiles);
    const selectedPositions = allProfiles.filter(position => selectedProfiles.includes(position.positionId));
    setSelectedPosition(selectedPositions)
    setAdditionalData?.([]);
    hideNotification();
    onSelectedAttributes?.(selectedAttributesState);
    onSelectedTags?.(selectedTags);
  }, [
    transferValue,trueValue, wagesValue, contractUntilValue, selectedPlayerZones, selectedAttributesState, isAllPosition,
    minAppearances, startsOnly, foot, regionValues, competitionValues, selectedTags, ageRange, isExactMatchesOnly,isAffordabilityFilter,isStylisticFilter,
    allProfiles, selectedProfiles, hideNotification, onSelectedAttributes
  ]);

  const commonAction = (
    <div className='notification-action'>
      <SecondaryButton label='Cancel' onClick={handleCancel} />
      <PrimaryButton iconType='refresh' label='Run new Search'
        onClick={handleRunNewSearch} />
    </div>
  );

  const generateMessage = () => {
    return (
      <div className='notification-message'>
        <Search />
        <div className='message-content'>
          <LabelText className='notification-title'>Filters altered</LabelText>
          <div className='notification-message'>
            <LabelText className='notification-text'>Changes to: </LabelText>
            <LabelText className='notification-alter-text'>{additionalData.join(', ')}</LabelText>
          </div>
        </div>
      </div>
    );
  };

  const addAdditionalData = useCallback((message: string) => {
    if (!additionalData.includes(message)) {
      setAdditionalData?.(prev => [...prev, message]);
    }
  }, [additionalData]);
  const debouncedAddAdditionalData = debounceFunction(addAdditionalData, 500);
  const removeData = (changeToRemove: string) => {
    setAdditionalData?.(prevChanges =>
      prevChanges.filter(change => change !== changeToRemove)
    );
  };

  const handleRemovePlayer = (playerId: number) => {
    addAdditionalData('Similar Player');
    setIsRemovePlayer(true);
  };

  const fetchPositionData = useCallback(async (zoneIds: number[]) => {
    if (zoneIds.length > 0) {
      try {
        const requestParameters = {
          zoneIds: zoneIds
        };
        const response: IApiResponse<IPositionSearchByZoneResponse[]> = await postData(
          apiUrls.SearchPositionbyZone,
          requestParameters
        );
        handleApiResponse(response, (positionData) => {
          // if (selectedPosition.length > 0) {
          //   const selectedPositionIds = selectedPosition.map(pos => pos.positionId);
          //   setSelectedPosition(selectedPosition.length > 0 ?
          //     positionData.filter(position => selectedPositionIds.includes(position.positionId)) : []);
          // }
          setAllPlayerProfiles(positionData);
          setSelectedPosition(positionData)
          setAllProfiles(positionData);
        }, (error) => {
          console.error("Error fetching position data:", error);
        }
        );
      } catch (error: any) {
        console.error("Error fetching position data:", error);
      }
    }
  }, [selectedPosition]);

  const handleSelectedAreaChange = (zones: IZoneArray[] | undefined) => {
    if (zones) {
      const zoneIds = zones.map((zone: any) => zone.id);
      setSelectedAreas(zoneIds);
      // handleSelectedPlayerZones(zoneIds);
      addAdditionalData('Zones of play');
      setSelectedPositionIds(zoneIds);
      if (selectedAreas && selectedPlayerZones) {
        setIsAltered((selectedAreas?.length > 0 && selectedPlayerZones?.length > 0)
          && !arraysEqual(zoneIds, selectedPlayerZones));
      }
    }
  };

  const handleSelect = (item: IPositionSearchByZoneResponse | IPositionSearchByZoneResponse[] | null, selected: boolean) => {
    if (Array.isArray(item)) {
      addAdditionalData('Related Profiles');
      const positionIdsArray: number[] = item.map(position => position.positionId);
      const isEqual = arraysEqual(positionIdsArray, selectedProfiles)
      setSelectedPosition(item);
      if (!isEqual)
        setIsAltered(true);
      else
        setIsAltered(false);
    }
    else {
      setSelectedPosition([]);
    }
  };

  const hanldeInfoClick = (archId: number,archName : string) => {
    setSidebarOpen(true)
    setArchetypeID(archId);
    setActiveArchetypeName(archName)

};

  const renderProfileItems = () => {
    return allPlayerProfiles?.map(position => (
          <PlayerPositionProfile key={position.positionName} item={position} />
    ));
  };

  const renderSelectedAttributes = () => {
    return selectedAttributes?.map((attr, index) => (
      <SelectedAttributes key={attr.id} className='selected-filter-attributes attribute-content'>
        <LabelText className='squad-chart-tooltip'>{attr.label === 'Contribution score' ? 'Attack Contribution' : attr.label}</LabelText>
        <div className='selected-attributes-percentiles  '>
          <div className='percentile-box'>
            <NumberTextField
              maxLength={attr.id === 'Height Cm' ? 3 : 2}
              uniqueKey={attr.id}
              value={attr.percentile}
              onChange={(e) => handlePercentileChange(attr.label, attr.id, parseFloat(e.target.value) || 0)}
            />
          </div>
          <CloseIcon className='cta-btn-icons' onClick={() => removeAttributes(attr.id)} />
        </div>
      </SelectedAttributes>
    ))
  }

  const toggleSection = useCallback((section: keyof ISectionState) => {
    setIsOpen(prevState => ({ ...prevState, [section]: !prevState[section] }));
  }, []);

  const handleTransferValueSliderChange = (min: number, max: number) => {
    setPlayerTransferValue(prevRange => ({
      min: min !== undefined ? min : prevRange.min,
      max: max !== undefined ? max : prevRange.max
    }));
    addAdditionalData('Transfer Value');
  };
    const handleTrueValueSliderChange = (min: number, max: number) => {
    setPlayerTrueValue(prevRange => ({
      min: min !== undefined ? min : prevRange.min,
      max: max !== undefined ? max : prevRange.max
    }));
    addAdditionalData('True Value');
  };

  const handleWagesSliderChange = (min: number, max: number) => {
    setPlayerWagesValue(prevRange => ({
      min: min !== undefined ? min : prevRange.min,
      max: max !== undefined ? max : prevRange.max
    }));
    addAdditionalData('Wages Value');
  };

  const handleContractValueSliderChange = (min: number, max: number) => {
    setPlayerContractUntilValue(prevRange => ({
      min: min !== undefined ? min : prevRange.min,
      max: max !== undefined ? max : prevRange.max
    }));
    addAdditionalData('Contract - Months Left');
  };

  const handleAgeSliderChange = (min: number, max: number) => {
    setPlayerAgeRange(prevRange => ({
      min: min !== undefined ? min : prevRange.min,
      max: max !== undefined ? max : prevRange.max
    }));
    addAdditionalData('Age range');
  };

  useEffect(() => {
    // Focus the input after the state update
    if (numberInputRef.current) {
      numberInputRef.current.focus();
    }
  }, [playerMinAppearances]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || 0;
    if (newValue !== playerMinAppearances) { // Only update if the value changes
      setPlayerMinAppearances(newValue);
      settxtInputWidth(Math.max(50, e.target.value.length * 20)); // Adjust width based on length
      addAdditionalData('Min. Mins Played Changed');
    }
  }, [playerMinAppearances, setPlayerMinAppearances, addAdditionalData]);

  const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setPlayerStartsOnly(!playerStartsOnly);
    addAdditionalData('Starts only')
  };

  const handleFootChange = (selectedFoot: any) => {
    const selectedOptionIds = selectedFoot.map((item: any) => item.optionId);
    addAdditionalData('Foot');
    setSelectedFootOptions(selectedOptionIds);
  }

  const handleSelectionClubLeagueChange = (selectedOptions: ISelectedOption[], region: string) => {
    addAdditionalData('Club League');
    setCompetition(prevRegion => {
      // Group the roles by competition
      const rolesByRegion: Record<string, ISelectedOption[]> = {};
      prevRegion.forEach(competition => {
        if (!rolesByRegion[competition.region]) {
          rolesByRegion[competition.region] = [];
        }
        rolesByRegion[competition.region].push(competition);
      });
      // Remove existing options from the same region
      selectedOptions.forEach(newOption => {
        const existingOptions = rolesByRegion[newOption.region];
        if (existingOptions) {
          existingOptions.forEach(existingOption => {
            const index = prevRegion.findIndex(area => area.optionId === existingOption.optionId);
            if (index !== -1) {
              prevRegion.splice(index, 1);
            }
          });
        }
      });
      // Concatenate the unique options with the previous roles
      let updatedRegions = [...prevRegion];
      // If selectedOptions is empty, remove all options for the region
      if (selectedOptions.length === 0) {
        updatedRegions = updatedRegions.filter(area => area.region !== region);
      } else {
        updatedRegions = [...updatedRegions, ...selectedOptions];
      }
      return updatedRegions;
    });
  };

  const handleSelectionRegionChange = (selectedOptions: ISelectedOption[], region: string) => {
    addAdditionalData('Regions');
    setRegion(prevRegion => {
      // Group the roles by region
      const rolesByRegion: Record<string, ISelectedOption[]> = {};
      prevRegion.forEach(area => {
        if (!rolesByRegion[area.region]) {
          rolesByRegion[area.region] = [];
        }
        rolesByRegion[area.region].push(area);
      });
      // Remove existing options from the same region
      selectedOptions.forEach(newOption => {
        const existingOptions = rolesByRegion[newOption.region];
        if (existingOptions) {
          existingOptions.forEach(existingOption => {
            const index = prevRegion.findIndex(area => area.optionId === existingOption.optionId);
            if (index !== -1) {
              prevRegion.splice(index, 1);
            }
          });
        }
      });
      // Concatenate the unique options with the previous roles
      let updatedRegions = [...prevRegion];
      // If selectedOptions is empty, remove all options for the region
      if (selectedOptions.length === 0) {
        updatedRegions = updatedRegions.filter(area => area.region !== region);
      } else {
        updatedRegions = [...updatedRegions, ...selectedOptions];
      }
      return updatedRegions;
    });
  };

  const removeAttributes = (id: string) => {
    const attributesList = selectedAttributes.filter((attr) => attr.id !== id);
    !additionalData.includes('Attributes Added') && addAdditionalData('Attributes Removed');
    setSelectedAttributes(attributesList);
    onSelectedAttributes?.(attributesList);
  };

  const handlePositionsChange = (e: any) => {
    addAdditionalData('Position changed');
    setSelectedOption(e.target.value);
  };
  const removeTag = (id: string) => {
    const tagList = selectedPlayerTags.filter((tag) => tag.id !== id);
    !additionalData.includes('Tags Added') && addAdditionalData('Tags removed');
    setSelectedPlayerTags(tagList);
    onSelectedTags?.(tagList);
  }

  const handleZonePositionData = (data: IPlayerZonePosition) => {
    setSelectedAreas(data?.zones || []);
    const allPositionList = data?.position?.playerPositions || [];
    const selectedProfileItems = data?.position?.selectedPosition || [];
    setAllPlayerProfiles(allPositionList);
    const filteredPositions = allPositionList.filter(position => selectedProfileItems.includes(position.positionId));
    setSelectedPosition(filteredPositions);
  }

  const handleAttributesData = (data: IPlayerAttributesData) => {
    const attributesData = data;
    const playerAttributesUniverse = attributesData.playerAttributesUniverseTheirPos;
    const updatedSections = attributeSections.map((section) => ({
      ...section,
      attributes: section.attributes.map((attribute) => {
        let score: number | null = null;
        // Determine the score based on the attribute ID
        switch (attribute.id) {
          case 'Height Cm':
            score = attributesData.heightInCM;
            break;
          case 'Av. contribution score':
            score = playerAttributesUniverse.overall.performanceValue;
            break;
          case 'finishing-shots':
            score = playerAttributesUniverse.finalThird.finishingShots.score;
            break;
          case 'finishing-aerial':
            score = playerAttributesUniverse.finalThird.finishingAerial.score;
            break;
          case 'attack-positioning':
            score = playerAttributesUniverse.finalThird.attackPositioning.score;
            break;
          case 'creativity':
            score = playerAttributesUniverse.buildUpPlay.creativity.score;
            break;
          case 'passing-accuracy':
            score = playerAttributesUniverse.buildUpPlay.passingAccuracy.score;
            break;
          case 'dribbling':
            score = playerAttributesUniverse.buildUpPlay.dribbling.score;
            break;
          case 'crossing':
            score = playerAttributesUniverse.buildUpPlay.crossing.score;
            break;
          case 'tackling':
            score = playerAttributesUniverse.defence.tackling.score;
            break;
          case 'defensive-headers':
            score = playerAttributesUniverse.defence.defensiveHeaders.score;
            break;
          case 'aggression':
            score = playerAttributesUniverse.defence.aggression.score;
            break;
          default:
            return attribute; // If no match, return the original attribute
        }
        // Return the updated attribute with the checked property based on score
        return {
          ...attribute,
          checked: score !== null && score !== 0, // Set checked to true only if score is not null and not 0
          percentile: score,
        };
      }),
    }));
    const selectedAttributelist = updatedSections.flatMap(section => section.attributes).filter(attribute => attribute.checked);
    setSelectedAttributes(selectedAttributelist);
    onSelectedAttributes?.(selectedAttributelist);
  }

  const handleConfirmAttributes = (selectedData: IAttribute[]) => {
    addAdditionalData('Attributes Added');
    setSelectedAttributes(selectedData);
    onSelectedAttributes?.(selectedData);
    setIsAltered(!areAttributesEqual(selectedData, selectedAttributesState));
  }

  const handleTagConfirm = (selectedData: ITag[]) => {
    addAdditionalData('Tags Added');
    setSelectedPlayerTags(selectedData);
    onSelectedTags?.(selectedData);
  }

  const handleModalAcceptButtonClick = () => {
    if (isRemovePlayer) {
      handleSelectedPlayer([]);
      setIsRemovePlayer(false);
      removeData('Similar Player');
      setIsAltered(false);
      setIsPlayerFilterChange(true);
      setModalState({ ...modalState, isOpen: false });
    }
  }
  const handleModalCancelButtonClick = () => {
    handleCancel();
    setModalState({ ...modalState, isOpen: false });
  };

  const handleExactMatch = () => {
    setIsExactMatch(!isExactMatch);
    addAdditionalData('ExactMatch changed');
  }



  const handlePercentileChange = useCallback((sectionTitle: string, id: string, value: number) => {
    const updatedAttributes = selectedAttributes.map(attr =>
      attr.id === id ? { ...attr, percentile: value, isMadeUpScore: true } : attr
    );
    // Set the updated attributes in state
    setSelectedAttributes(updatedAttributes);
    const index = selectedAttributes.findIndex(attr => attr.label === sectionTitle);
    if (inputRefs.current[index]) {
      inputRefs.current[index]?.focus();
    }
    addAdditionalData('attributes value changed');
    onSelectedAttributes?.(updatedAttributes);
  }, [addAdditionalData, selectedAttributes]);

  const handleSelectPlayer = (playerId: number) => {
    addAdditionalData('player added');
  }

  return (
    <>
      <div className='player-search-filter-wrapper'>
        <PlayerSearchFilterStyles className='player-search-filter-sections'>
          <div className='search-for-similar'>
            {originPage != 'Similarplayers Tab' &&
              <>
                <LabelText className='player-search-text'>Benchmark player</LabelText>
                <SearchForSimilarPlayers
                  selectedPlayers={selectedPlayers}
                  onZonePositionData={handleZonePositionData}
                  onPlayerAttributesData={handleAttributesData}
                  onRemovePlayer={handleRemovePlayer}
                  onSelectPlayer={handleSelectPlayer}
                />
              </>
            }
             {isFromSuccession && (
              <>
                <div className="toggle-filter-content">
                    <LabelText className='player-given-name'>Affordability</LabelText>
                    <Switch id="exact-match"
                      toggled={isAffordability} onChange={()=>{
                        setIsAffordability(!isAffordability)
                        addAdditionalData('Affordability changed');
                      }}
                      source='Filter' isByComparison={false} />
                </div>
                <div className="toggle-filter-content">
                  <LabelText className='player-given-name'>Stylistic fit uplift</LabelText>
                  <Switch id="exact-match"
                    toggled={isStlisticfit} onChange={()=>{
                      setIsStylisticfit(!isStlisticfit)
                      addAdditionalData('Stylistic fit changed');
                    }}
                    source='Filter' isByComparison={false} />
                </div>
              </>
            )}
              {selectedPlayers.length > 0 && !isFromSuccession &&
                <div className="toggle-filter-content">
                  <LabelText className='player-given-name'>Exact matches only</LabelText>
                  <Switch id="exact-match"
                    toggled={isExactMatch} onChange={handleExactMatch}
                    source='Filter' isByComparison={false} />
                </div>}
          </div>
          <div className='zones-of-play'>
            <LabelText className='player-search-text'>Zones of play</LabelText>
            <Pitch isPattern={false} selectedZones={selectedAreas}
              onSelectedZonesChange={handleSelectedAreaChange} isZones />
            {allPlayerProfiles.length > 0 && (
              <div className='filter-profile-list'>
                <CustomList<IPositionSearchByZoneResponse>
                  selectedItems={selectedPosition}
                  onSelect={handleSelect}
                  multiSelection={true}
                  isCheckBox={true}
                  showSelectAllCheckbox={true}
                  isDropdown={true}
                >
                  {renderProfileItems()}
                </CustomList>
              </div>
            )}
          </div>
          {isFromSuccession === false && (
              <Section label='Attributes' isOpen={isOpen.toppercentiles!} toggle={() => toggleSection('toppercentiles')}>
                  <TopPercentiles className='top-percentiles'>
                    {selectedAttributes.length === 0 && (
                      <LabelText>Add any attributes of importance.</LabelText>
                    )}
                    <PrimaryButton
                      label={selectedAttributes.length > 0 ? 'Add more' : 'Add attributes'} iconType='add'
                      onClick={() => { setAttributesDrawerOpen(true) }} />
                    {selectedAttributes.length > 0 && (
                      selectedAttributes.map((attr, index) => (
                        <SelectedAttributes key={attr.id} className='selected-filter-attributes attribute-content'>
                          <LabelText className='squad-chart-tooltip'>{attr.displayName === 'Contribution score' ? 'Attack Contribution' : attr.displayName}</LabelText>
                          <div className='selected-attributes-percentiles  '>
                            <div className='percentile-box'>
                              <NumberTextField
                                id={attr.id}
                                value={attr.percentile}
                                onChange={(e) => handlePercentileChange(attr.label, attr.id, parseFloat(e.target.value) || 0)}
                              />
                            </div>
                            <CloseIcon className='cta-btn-icons' onClick={() => removeAttributes(attr.id)} />
                          </div>
                        </SelectedAttributes>
                      ))
                    )}
                    </TopPercentiles>
                </Section>
          )}
          
          <Section label='Financial' isOpen={isOpen.financial} toggle={() => toggleSection('financial')}>
            <BarChart
              header="Market value"
              data={valueSliderData}
              onDataUpdate={handleTransferValueSliderChange}
              initialMinValue={0}
              initialMaxValue={250000000}
              defaultSelectedValue={[playerTransferValue.min, playerTransferValue.max]}
              isFor={'Transfer Value'}
            />
            <BarChart
              header="True value"
              data={valueSliderData}
              onDataUpdate={handleTrueValueSliderChange}
              initialMinValue={0}
              initialMaxValue={250000000}
              defaultSelectedValue={[playerTrueValue.min, playerTrueValue.max]}
              isFor={'Transfer Value'}
            />
            <BarChart
              header="WAGES €"
              data={wagesSliderData}
              onDataUpdate={handleWagesSliderChange}
              initialMinValue={0}
              initialMaxValue={180000000}
              defaultSelectedValue={[playerWagesValue.min, playerWagesValue.max]}
              isFor={'Transfer Value'} />
            <BarChart
              header="contract - months left"
              data={wagesSliderData}
              onDataUpdate={handleContractValueSliderChange}
              initialMinValue={0}
              initialMaxValue={120}
              defaultSelectedValue={[playerContractUntilValue.min, playerContractUntilValue.max]} />
          </Section>
          <Section label='Statistical' isOpen={isOpen.statistical} toggle={() => toggleSection('statistical')}>
            {ageStatistics !== null && ageStatistics.ageDistribution.length > 0 &&
              <BarChart
                isDisplaySVG={true}
                header="age"
                data={ageStatistics.ageDistribution}
                onDataUpdate={handleAgeSliderChange}
                initialMinValue={16}
                initialMaxValue={50}
                defaultSelectedValue={[playerAgeRange.min, playerAgeRange.max]}
              />}
            <Foot>
              <div className='starts-only'>
                <LabelText className='team-selection-text'>Min. mins played</LabelText>
                <InputFeild
                  maxLength={5}
                  uniqueKey="minsPlayed"
                  value={playerMinAppearances}
                  onChange={handleChange}
                  id='minsPlayed'
                  style={{
                    width: `${txtInputWidth}px`,
                    transition: "width 0.2s ease",
                  }}
                />
              </div>
              <div className='starts-only'>
                <LabelText>Starts only</LabelText>
                <Switch id="starts-only"
                  toggled={playerStartsOnly} onChange={handleSwitchClick}
                  source='Filter' isByComparison={false} />
              </div>
            </Foot>
          </Section>
          <Section label='Preferred foot' isOpen={isOpen.Preferredfoot} toggle={() => toggleSection('Preferredfoot')}>
            <FilterDropdown
              key={footValue}
              region={'All options'}
              options={footLabels}
              defaultSelectedOptions={selectedFootOptions
                .filter(item => item)
                .map(item => item)}
              onChange={handleFootChange}
              includeAll={true}
              displayAsDropdown={true}
            />
          </Section>
          <Section label='Club league' isOpen={isOpen.clubleague} toggle={() => toggleSection('clubleague')}>
            {clubLeagueData?.map(comp => (
              <FilterDropdown
                key={comp.region}
                region={comp.region}
                options={comp.competitions}
                type={comp.region}
                onChange={handleSelectionClubLeagueChange}
                defaultSelectedOptions={competition
                  .filter(item => item.region === comp.region)
                  .map(item => item.optionId)}
                includeAll={true}
                displayAsDropdown={true}
              />
            ))}
          </Section>
          <Section label='Nationality' isOpen={isOpen.region} toggle={() => toggleSection('region')}>
            {regionAreaData?.map(regionItem => (
              <FilterDropdown
                key={regionItem.region}
                region={regionItem.region}
                options={regionItem.areas}
                type={regionItem.region}
                onChange={handleSelectionRegionChange}
                defaultSelectedOptions={region
                  .filter(item => item.region === regionItem.region)
                  .map(item => item.optionId)}
                includeAll={true}
                displayAsDropdown={true}
              />
            ))}
          </Section>
          <Section label='Tags' isOpen={isOpen.tags} toggle={() => toggleSection('tags')} >
            <div className='top-percentiles'>
              {selectedPlayerTags.length === 0 && (
                <LabelText>Add any tags of importance.</LabelText>
              )}
              <PrimaryButton
                label={selectedPlayerTags.length > 0 ? 'Add more' : 'Add tags'} iconType='add'
                onClick={() => { setTagsDrawerOpen(true) }} />
              {selectedPlayerTags.length > 0 && (
                selectedPlayerTags.map((tag, index) => (
                  <SelectedAttributes key={index} className='selected-filter-attributes'>
                    <LabelText className='squad-chart-tooltip'>{tag.label}</LabelText>
                    <div className='selected-attributes-percentiles'>
                      <CloseIcon className='cta-btn-icons' onClick={() => removeTag(tag.id)} />
                    </div>
                  </SelectedAttributes>
                ))
              )}
            </div>
          </Section>
        </PlayerSearchFilterStyles>
        <SmallModal
          isOpen={modalState.isOpen}
          onAcceptClick={handleModalAcceptButtonClick}
          onCancelClick={handleModalCancelButtonClick}
          headerMessage={modalState.headerMessage}
          bodyMessage={modalState.bodyMessage}
          footerMessage={modalState.footerMessage}
          acceptLabel={modalState.acceptLabel}
          cancelLabel="Cancel"
        />
      </div>
      {/* <ArchetypeInfoDrawer
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          //archetypeName={archetypeData[0]?.archetypeName!}
          //activeArchetypeID={archetypeData[0]?.archetypeId!}
          archetypeName={activeArchetypeName}
          activeArchetypeID={archetypeID}
        /> */}
    </>
  )
});

export default React.memo(PlayerFilterSection);

